/** Date-only booking cutoff in the partner's local timezone (not elapsed hours). */
export function minimumBookingDate(
  leadDays: number,
  timeZone: string,
  now: Date = new Date(),
): string {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const part = (type: string) => parts.find((p) => p.type === type)!.value;
  const date = new Date(`${part("year")}-${part("month")}-${part("day")}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + Math.max(0, Math.trunc(leadDays)));
  return date.toISOString().slice(0, 10);
}

export function isBeforeBookingCutoff(
  pickupDate: string,
  leadDays: number,
  timeZone: string,
  now: Date = new Date(),
): boolean {
  if (!Number.isFinite(leadDays) || leadDays <= 0) return false;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(pickupDate)) return true;
  const parsed = new Date(`${pickupDate}T00:00:00Z`);
  if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== pickupDate) return true;
  return pickupDate < minimumBookingDate(leadDays, timeZone, now);
}
